
import Vue from "vue"
import {Inject, Prop} from "vue-property-decorator"
import Component from "vue-class-component"
import {Campaign, CampaignService} from "@/CampaignService"
import {PlanService} from "@/superannuation/PlanService"
import {format, formatMonth} from "@/utils/date"

@Component({})
export default class CampaignTable extends Vue {
  @Prop()
  tableType: "email" | "welcome" | "report"

  @Inject()
  campaignService: CampaignService

  @Inject()
  planService: PlanService

  campaignData: Array<unknown> = []

  isLoading = true

  async created() {
    this.$watch(
      () => this.planService.current,
      async plan => {
        if (!plan) return

        const campaigns = await this.campaignService.getCampaigns(plan.id)
        this.campaignData = campaigns
          .map(campaign => this.toRow(campaign))
          .filter(row => row !== null)
        this.isLoading = false
        this.$emit("loaded", this.campaignData.length)
      },
      {immediate: true}
    )
  }

  private toRow(campaign: Campaign): Record<string, unknown> | null {
    const {isEmail, isWelcome, isReport} = this.matchTableType(campaign)
    if (!isEmail && !isWelcome && !isReport) return null

    return {
      name: campaign.type,
      topic: isWelcome ? "Registration" : "SuperScore",
      date: isWelcome ? formatMonth(campaign.date) : format(campaign.date),
      recipients: campaign.recipients,
      ...(isEmail || isWelcome ? this.toRateFields(campaign) : {}),
    }
  }

  private matchTableType(
    campaign: Campaign
  ): {isEmail: boolean; isWelcome: boolean; isReport: boolean} {
    return {
      isEmail: campaign.type === CampaignService.CAMPAIGN_TYPE_EMAIL && this.tableType === "email",
      isWelcome:
        campaign.type === CampaignService.CAMPAIGN_TYPE_WELCOME && this.tableType === "welcome",
      isReport:
        campaign.type === CampaignService.CAMPAIGN_TYPE_REPORT && this.tableType === "report",
    }
  }

  private toRateFields(campaign: Campaign) {
    return {
      openRate: campaign.opened,
      clickRate: campaign.clicked,
      conversionRate: `${((campaign.clicked / campaign.recipients) * 100).toFixed(2)}%`,
    }
  }

  get columns() {
    const headers = [
      {
        name: "campaign name",
        required: true,
        align: "left",
        label: "CAMPAIGN NAME",
        field: "name",
      },
      {name: "topic", align: "left", label: "TOPIC", field: "topic"},
      {name: "date", align: "left", label: "DATE", field: "date"},
      {
        name: "recipients",
        align: "left",
        label: "RECIPIENTS",
        field: "recipients",
      },
    ]
    if (this.tableType === "email" || this.tableType === "welcome") {
      headers.push(
        {
          name: "open rate",
          align: "left",
          label: "OPEN RATE",
          field: "openRate",
        },
        {
          name: "click rate",
          align: "left",
          label: "CLICK RATE",
          field: "clickRate",
        },
        {
          name: "conversion rate",
          align: "left",
          label: "CONVERSION RATE",
          field: "conversionRate",
        }
      )
    }

    return headers
  }
}
